import { facultyData } from '../facultyData';

export const teluguData = {
  departmentName: "Department of Telugu",
  bannerImage: "/infrastructure/telugu/class-4.JPG",
  
  about: {
    title: "About the Department",
    content: `The Department of Telugu is dedicated to preserving and promoting Telugu language, literature, and culture. 
    We offer comprehensive programs in classical and modern Telugu literature, linguistics, and cultural studies.`,
    highlights: [
      "Rich library of Telugu literature",
      "Regular literary activities and events",
      "Research in Telugu linguistics and literature",
      "Cultural preservation initiatives"
    ]
  },

  brochure: {
    title: "Department Brochure",
    pdfLink: "/telugu/department-brochure.pdf",
    description: "Download our department brochure."
  },

  hod: {
    id:'tel001',
    name: "Dr. N. Narasimhulu",
    designation: "Professor & Head",
    photo: "/telugu/Narasimhulu.JPG",
    email: "drnnarasimhuluknl@gmail.com",
    mobile: "9182034667",
    qualification: "M.A (Telugu) M.Phil, Ph.D ",
    specialization: "Folk Literature",
    message: `Welcome to the Department of Telugu.`,
    profileLink: "/telugu/NARASIMHULU.pdf"
  },

  bos: {
  title: "Telugu",
  members: [
    {
      name: "Prof. N. Narasimhulu",
      designation: "Chairperson",
      affiliation: "Dept. of Telugu, Rayalaseema University, Kurnool"
    },
    {
      name: "Prof. T. Ramprasad Reddy",
      designation: "Member",
      affiliation: "Dept. of Telugu, Yogi Vemana University, Kadapa"
    },
    {
      name: "Prof. G. Balasubramanyam",
      designation: "Member",
      affiliation: "Dept. of Telugu, S.K. University, Anantapur"
    },
    {
      name: "Prof. D. Venkateswar Rao",
      designation: "Member",
      affiliation: "Dept. of Telugu, University of Hyderabad, Telangana"
    },
    {
      name: "Prof. Vistali Sankara Rao",
      designation: "Member",
      affiliation: "Head, Dept. of Telugu, University of Madras"
    },
    {
      name: "Prof. S. Chinna Reddaiah",
      designation: "Member",
      affiliation: "Dept. of Telugu, Dravidian University, Kuppam"
    }
  ]
}
,

  faculty: facultyData.telugu.faculty,

  courses: {
    // undergraduate: [
    //   {
    //     name: "B.A. Telugu",
    //     duration: "3 Years",
    //     eligibility: "10+2",
    //     intake: "60 seats"
    //   }
    // ],
    postgraduate: [
      {
        name: "M.A. Telugu",
        duration: "2 Years",
        eligibility: "B.A. Telugu",
        intake: "30 seats"
      }
    ],
    research: [
      {
        name: "Ph.D. in Telugu",
        duration: "Minimum 3 Years",
        eligibility: "M.A. Telugu",
        areas: "Telugu Literature, Linguistics, Cultural Studies"
      }
    ]
  },

  Infrastructure: [
  "/infrastructure/telugu/class-1.JPG",
  "/infrastructure/telugu/class-2.JPG",
  "/infrastructure/telugu/class-3.JPG",
 
]
};